module.exports = __webpack_public_path__ + "img/visa.1deb435f.png";